import React from 'react';
import { ProfileImage } from 'components/ProfileImage';
import { PrimaryButtonLink, SecondaryButton, PrimaryButton } from 'styleguide/Buttons';
import { TextMD, TextSMRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { RoutineDetailViewModel } from '../RoutineDetailViewModel';
import { Link } from 'components/Link';

export const RoutineOwnerContent = ({ vm }: { vm: RoutineDetailViewModel }) => {
  return (
    <View>
      <View style={{ marginBottom: Spacing.lg }}>
        <Link href={`/user/${vm.username}`} style={{ display: 'flex', flexDirection: 'row' }}>
          <ProfileImage diameter={56} source={vm.routineOwnerProfilePic} />
          <View style={{ marginLeft: Spacing.md, justifyContent: 'center' }}>
            <TextSMRegular>Created by</TextSMRegular>
            <TextMD>{vm.username}</TextMD>
          </View>
        </Link>
      </View>

      {vm.isAuthenticated &&
        (vm.isUsersRoutine ? (
          <PrimaryButtonLink
            title="Edit Routine"
            style={{ marginBottom: Spacing.sm }}
            to={`/edit-routine/${vm.routineId}`}
          />
        ) : (
          <View>
            {vm.isRoutineSaved ? (
              <SecondaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onExistingUserSaveRoutine}
              />
            ) : (
              <PrimaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onExistingUserSaveRoutine}
              />
            )}
          </View>
        ))}

      <SecondaryButton title="Copy Routine Link" onClick={vm.onCopyUrl} iconType={'link'} />
    </View>
  );
};
